
import { Component, OnInit, ViewChild } from "@angular/core";
import { AbstractControl, FormControl, FormGroup, Validators } from "@angular/forms";
import { IonContent, LoadingController, NavParams, Platform, PopoverController } from "@ionic/angular";
import { Navigator } from "src/app/services/routing/navigator";
import { CashierContentService } from "src/app/services/cashier/cashier-content.service";
import { CashierService } from "src/app/services/cashier/cashier.service";
import { ConfigService } from "src/app/services/config/config.service";
import { EventsService } from "src/app/services/event/event.service";
import { SuccessMessageService } from "src/app/services/message-provider/success-message.service";
import { UtilsService } from "src/app/services/utils/utils.service";
import { CashierBase } from "../../cashier-base/cashier-base";
import { DepositMainLabels } from "src/app/interfaces/deposit-main-labels";
import { InstaModel } from "../cashier-models/models";
import { RoutingService } from "src/app/services/routing/routing.service";

@Component({
  selector: "page-deposit-instadebit",
  templateUrl: "deposit-instadebit.html",
})

export class DepositInstaDebitPage extends CashierBase implements OnInit {

  @ViewChild("Content") content: IonContent;
  public error = null;

  public objectKeys = Object.keys;

  // public amount: string;
  private bonusCode: string;
  private bonusID: string;

  public buttonDisabled: boolean = false;
  public showInstaDebit: boolean = false;

  public selectedBonusItem: string;

  // enroll form
  public depositForm: FormGroup;

  public defaultAmounts: any = [];
  private paymentType: any = [];
  public vendorLogoUrl: string = "";

  private inputInstaDebitAmount: AbstractControl;
  public amountSubmitted: number;

  public labels: DepositMainLabels;
  public newWindow;

  public paypalEmail = "";
  public accountsList = null;
  public loading;
  public minAmount;

  // Payment Succesfull Variables
  public params;
  public paymentRequestID;
  public customerId;
  public sessionToken;

  public check_deposit_complete: boolean = false;
  public check_deposit_result: string;

  constructor(
    protected config: ConfigService,
    protected cashierProvider: CashierService,
    protected successMessageService: SuccessMessageService,
    protected events: EventsService,
    protected navParams: NavParams,
    private navigator: Navigator,
    protected utils: UtilsService,
    public platform: Platform,
    private contentProvider: CashierContentService,
    private loadingController: LoadingController,
    protected popoverCtrl: PopoverController,
    private routing: RoutingService,
  ) {
    super();

    this.labels = new InstaModel();

    this.bonusCode = navParams.get("bonusCode");

    this.successMessageService.clearMessage();

    if (!!this.navParams.get("bonusOffer"))
      this.bonusCode = this.navParams.get("bonusOffer");

    if (!!this.navParams.get("navigateBackPage")) {
      this.loading = this.loadingController.create({
        message: "Loading INSTADEBIT...",
      });

      this.loading.then((loadingDialog) => {
        loadingDialog.present();
      });
      setTimeout(() => {
        this.loading.then((loadingDialog) => {
          loadingDialog.dismiss();
        });
      }, 650);



    }
  }

  ngOnInit() {
    this.buttonDisabled = false;

    this.depositForm = new FormGroup({
      inputInstaDebitAmount: new FormControl("", [Validators.required]),
    });
    this.inputInstaDebitAmount = this.depositForm.get("inputInstaDebitAmount");
  }

  ionViewWillEnter() {

    this.contentProvider
      .getPageConfig("instadebit")
      .then((response: DepositMainLabels) => {
        this.labels = response;
      });

    //Webservice Calls to get Credit Card Data

    this.cashierProvider.getActivePaymentTypes("INSTA").subscribe(
      (response: any) => {
        if (response.result) {
          this.paymentType = response.payload;
          this.minAmount = this.paymentType[0].min;
          // this.onPaymentType(0);

          let i: number = 0;
          this.defaultAmounts = [];

          while (i < 11) {
            if (
              typeof this.paymentType[0]["default_amt_" + (i + 1)] !== "undefined"
            ) {
              this.defaultAmounts.push(
                this.paymentType[0]["default_amt_" + (i + 1)]
              );
            } else {
              break;
            }
            i++;
          }

          this.vendorLogoUrl = this.utils.getCDNAsset(
            "deposit/" + this.paymentType[0].image_url
          );
        }
      },
      (error) => { }
    );
  }

  selectedDepositBonusOffer($event) {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  showLoading() {
    this.hideLoading();
    this.loading = this.loadingController.create({
      message: "Checking Account...",
    });
    this.loading.present();
  }

  hideLoading() {
    try {
      this.loading.dismiss();
    } catch (e) { }
  }

  onSubmit() {
    let instadata: any = {};
    instadata.amount = this.inputInstaDebitAmount.value;
    instadata.bonusCode = this.bonusCode;
    instadata.bonusID = this.bonusID;
    instadata.currency_code = this.config.getConfig().DEFAULT_CURRENCY;
    instadata.payment_type_code = "INSTA";
    this.buttonDisabled = true;
    this.cashierProvider.callDeposit(instadata).subscribe(
      (response: any) => {
        if (response && !!response.result) {
          this.buttonDisabled = false;
          this.navigator.navigateTo(
            "DepositInstaDebitActionPage",
            { multipleModals: true },
            {
              amount: instadata.amount,
              paymentRequestID: response.payload.paymentRequestID,
              bonusCode: instadata.bonusCode,
              bonusID: instadata.bonusID,
            }
          );
        }
      },
      (error) => {
        this.buttonDisabled = false;
        // handle all deposit errors in base
        this.error = this.handleError(error);
        this.content?.scrollToTop();
      }
    );

    // Navigator.navigateTo(
    //   "CashierInstaDebitActionPage",
    //   { multipleModals: true },
    //   { amount: this.amount, bonusCode: this.bonusCode }
    // );
    return false;
  }

  get isMobile() {
    return this.platform.is("mobile") || this.platform.is("mobileweb")
      ? true
      : false;
  }

  isMobileApp() {
    return this.platform.is("cordova");
  }

  onBack = () => {
    if (!!this.navParams.get("navigateBackPage")) {
      let navigateBackPage = this.navParams.get("navigateBackPage");
      if (navigateBackPage == "default") {
        //Navigator.toLobby();
        this.navigator.navigateTo("DepositMainComponent", { multipleModals: true });
      } else if (navigateBackPage == "navbar" || navigateBackPage == "navbar-text") {
        return this.routing.defaultRoute();
      } else {
        this.navigator.navigateTo(navigateBackPage);
      }
    } else {
      this.navigator.back();
    }
  };

  onBonusSelect(index, offer) {
    this.bonusCode = offer.campaign_code;
    this.selectedBonusItem = index;

    //Deposit Event Information
    this.bonusID = offer.id;
  }

  onAmountSelected(amount) {
    this.inputInstaDebitAmount.setValue(amount);
    this.depositForm.get("inputInstaDebitAmount").markAsDirty();
    this.depositForm.get("inputInstaDebitAmount").markAsTouched();
  }

  // For Checking Payment Success

  getHashValue(key) {
    var matches = location.hash.match(new RegExp(key + "=([^&]*)"));
    return matches ? matches[1] : null;
  }
}
